import analyticsAPIModule from './modules/analytics-apis'

export const analyticsStore = {
  modules: {
    analyticsAPI: analyticsAPIModule
  }
}
